<template>
  <v-app-bar app flat fixed color="primary app-bar" tile class="navigationHeader" height="70px">
    <div class="mr-md-5 mr-sm-0 cursorPointer" @click="$emit('logoClick')">
      <v-img
        contain
        :max-width="logoWidthComputed"
        :max-height="logoHeightComputed"
        style="box-sizing: border-box;"
        :src="logo"
      ></v-img>
    </div>
    <v-spacer></v-spacer>
    <slot name="header"></slot>
    <slot name="main"></slot>
    <v-toolbar-items v-if="isAuthorized">
      <div v-if="appSwitcher && !supportAccess" class="pt-3 pr-2">
        <application-switcher iconColor="white" :applications="appSwitcher"></application-switcher>
      </div>
      <div v-if="supportAccess" class="support-access-warning">
        {{
          $t("You are logged in as EMAIL via support-access. When you close this tab you will be logged out.", {
            email: email,
          })
        }}
      </div>
      <slot name="account-menu"></slot>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import ApplicationSwitcher from "./menu/ApplicationSwitcher"

export default {
  name: "Header",
  components: {
    ApplicationSwitcher
  },
  props: [
    "logo",
    "isAuthorized",
    "appSwitcher",
    "supportAccess",
    "logoWidth",
    "logoHeight",
    "email"
  ],
  setup() {
    return {};
  },
  computed: {
    logoHeightComputed() {
      return this.logoHeight ? this.logoHeight : "50px";
    },

    logoWidthComputed() {
      return this.logoWidth ? this.logoWidth : "180px";
    },
  },
};
</script>

<style lang="scss" scoped>
.app-bar {
  height: 70px !important;
}
.navigationHeader {
  z-index: 1000;
}
.cursorPointer {
  cursor: pointer;
}
.support-access-warning {
  background-color: rgb(255, 255, 50);
  max-width: 350px;
  height: 60px;
  border-radius: 5px;
  font-weight: bold;
  font-size: 13px;
  line-height: 1.2;
  box-shadow: 0px 3px 15px #000000b2;
  margin-top: 5px;
  padding: 0 5px 0 10px;
  overflow-wrap: break-word;
}
</style>
